import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/history-tracking', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getObj = data => {
  return httpClient
    .get('/api/history-tracking/objects', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  getObj
}
